(() => {
  // Configuration - we'll get these from individual badge elements

  // GraphQL query to check if a product is a bundle
  const BUNDLE_CHECK_QUERY = `
    query ProductBundleCheck($handle: String!) {
      product(handle: $handle) {
        selectedOrFirstAvailableVariant {
          ... on ProductVariant {
            requiresComponents
            components(first: 1) {
              nodes {
                quantity
              }
            }
          }
        }
      }
    }
  `;

  // Function to check if a product is a bundle
  async function checkIfProductIsBundle(handle, token, shopDomain) {
    if (!shopDomain || !token) {
      return false;
    }

    try {
      const endpoint = `https://${shopDomain}/api/2025-01/graphql.json`;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token
        },
        body: JSON.stringify({
          query: BUNDLE_CHECK_QUERY,
          variables: { handle }
        })
      });

      if (!response.ok) {
        return false;
      }

      const data = await response.json();

      if (data.errors) {
        return false;
      }

      const variant = data?.data?.product?.selectedOrFirstAvailableVariant;
      const isBundle = !!variant?.requiresComponents;
      const hasComponents = variant?.components?.nodes?.length > 0;

      return isBundle && hasComponents;
    } catch (error) {
      return false;
    }
  }

  // Function to update badge text
  function updateBadgeText(element, isBundle) {
    const defaultText = element.querySelector('.badge-text-default');
    const bundleText = element.querySelector('.badge-text-bundle');
    const parentBadge = element.closest('.badge');

    if (defaultText && bundleText && parentBadge) {
      if (isBundle) {
        defaultText.style.display = 'none';
        bundleText.style.display = 'inline';
        // Replace on-sale class with bundle-and-save-badge class
        parentBadge.classList.remove('on-sale');
        parentBadge.classList.add('bundle-and-save-badge');
      } else {
        defaultText.style.display = 'inline';
        bundleText.style.display = 'none';
        // Replace bundle-and-save-badge class with on-sale class
        parentBadge.classList.remove('bundle-and-save-badge');
        parentBadge.classList.add('on-sale');
      }
    }
  }

  // Function to process all bundle badges on the page
  async function processBundleBadges() {
    const badgeElements = document.querySelectorAll('.bundle-badge-text');

    if (badgeElements.length === 0) return;

    // Process badges in batches to avoid overwhelming the API
    const batchSize = 5;
    for (let i = 0; i < badgeElements.length; i += batchSize) {
      const batch = Array.from(badgeElements).slice(i, i + batchSize);

      const promises = batch.map(async (element) => {
        const handle = element.getAttribute('data-product-handle');
        const token = element.getAttribute('data-sf-token');
        const shopDomain = element.getAttribute('data-shop-domain');

        if (!handle || !token || !shopDomain) {
          return;
        }

        try {
          const isBundle = await checkIfProductIsBundle(handle, token, shopDomain);
          updateBadgeText(element, isBundle);
        } catch (error) {
          // Silently fail to avoid breaking the page
        }
      });

      await Promise.all(promises);

      // Small delay between batches to be respectful to the API
      if (i + batchSize < badgeElements.length) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }
  }

  // Initialize when DOM is ready
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', processBundleBadges);
    } else {
      processBundleBadges();
    }
  }

  // Also run when new content is loaded (for dynamic content)
  const observer = new MutationObserver((mutations) => {
    let shouldCheck = false;
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList?.contains('bundle-badge-text') ||
              node.querySelector?.('.bundle-badge-text')) {
              shouldCheck = true;
            }
          }
        });
      }
    });

    if (shouldCheck) {
      setTimeout(processBundleBadges, 100);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initialize
  init();
})();
